import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getCurrentViewSelector, getPreviousViewSelector, closeView, popView } from './cardNavigationRedux';
import { closeIconSvg } from '../../../HelperMethods/constants';
import { ReactComponent as BackButtonLogo } from '../../../icons/back.svg';

const getPositionObject = (positionProps) => {
  const { top, bottom, left, right } = positionProps;
  const positionObject = { top, bottom, left, right };
  for (const key in positionObject) {
    if (_.isNil(positionObject[key])) {
      delete positionObject[key];
    }
  }
  if (_.isNil(positionObject.top) && _.isNil(positionObject.bottom)) {
    Object.assign(positionObject, { bottom: '0px' }); // default bottom value
  }
  if (_.isNil(positionObject.left) && _.isNil(positionObject.right)) {
    Object.assign(positionObject, { right: '0px' }); // default right value
  }
  return positionObject;
};

const CardNavigationComponent = React.memo(function CardNavigationComponent(props) {
  const { container } = props;
  const currentView = useSelector(getCurrentViewSelector(container));
  const previousView = useSelector(getPreviousViewSelector(container));
  const dispatch = useDispatch();
  if (!currentView) return null;
  const boxStyle = { zIndex: '99', position: 'fixed', padding: '0px' };
  Object.assign(boxStyle, getPositionObject(props));
  return (
    <>
      <div style={boxStyle}>
        <div style={{ position: 'absolute', top: '10px', right: '12px', zIndex: '2' }}>
          <img
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(closeIconSvg)}`}
            onClick={() => {
              dispatch(closeView(container));
            }}
            style={{ cursor: 'pointer' }}
            alt="Close Icon"
          />
        </div>
        {previousView && (
          <div
            style={{ position: 'absolute', top: '10px', left: '12px', zIndex: '2', cursor: 'pointer' }}
            onClick={() => {
              dispatch(popView(container));
            }}
          >
            <BackButtonLogo /> &nbsp;&nbsp;&nbsp;Back
          </div>
        )}
        {React.createElement(currentView.component, {
          ...props,
          ...currentView.props,
        })}
      </div>
    </>
  );
});

CardNavigationComponent.propTypes = {
  container: PropTypes.string.isRequired,
};

export default CardNavigationComponent;
